module.exports = __webpack_public_path__ + "static/media/website.5b1e46db.svg";